<template lang="pug">
div
  div.form-check.mb-3
    input#creative_countdown.form-check-input(type='checkbox', name='pr', @click='setCountdown', :checked="countdown", value=1)
    div.d-flex.align-items-center
      label.form-check-label(for='creative_countdown') カウントダウンタイマー表示
      span.upper-master-label.ml-2 Master以上
      UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
  div.form-group.pl-4(v-if="countdown")
    .row
      .col-12
        div.form-group
          label(for='creative_countdown_type') カウントダウン種別
          select.form-control(@change="updateCountdownType", v-model="countdown_type")
            option(v-for="(val, key) in countdown_types", :value="key") {{val}}
    .row(v-if="countdown_type == 'time_limit'")
      .col-12
        div.form-group
          label(for='time_limit_val') 残り時間
          .input-group
            input#time_limit_hour.form-control(type='number',
            name='time_limit_hour',
            placeholder='残り時間',
            @input='updateTimeLimitHour',
            :value="time_limit_hour")
            .input-group-append
              span.input-group-text 時間

            input#time_limit_min.form-control(type='number',
            name='time_limit_min',
            placeholder='残り分',
            @input='updateTimeLimitMin',
            :value="time_limit_min",
            min="0",
            max="59")
            .input-group-append
              span.input-group-text 分
    .row(v-if="countdown_type == 'specific_date'")
      .col-12
        div.form-group
          label(for='time_limit_specific_date') 終了日時
          .input-group
            input#time_limit_specific_date.form-control(type='datetime-local',
            name='time_limit_specific_date',
            placeholder='残り時間',
            @input='updateTimeLimitSpecificDate',
            :value="time_limit_specific_date")
    .row
      .col-12
        div.form-group
          label(for='countdown_name') タイトル
          input#prefix_countdown_text.form-control(type='text',
          name='prefix_countdown_text',
          placeholder='カウントダウンのタイトル',
          @input='updatePrefixCountdownText',
          :value="prefix_countdown_text")

    .row.mb-3
      .col-12
        label 背景色
        chrome(:value="countdown_bg_color", @input="updateBgColor")
    .row
      .col-12
        label 文字色
        chrome(:value="countdown_font_color", @input="updateFontColor")
</template>

<script>
//libs
import { Chrome } from 'vue-color'

import UpgradeUpperMaster from "../modals/upgrade_upper_master.vue";

export default {
  props: {
    countdown_types: {type: Object, default: null},
    show_with_parameters: { type: Boolean, default: false },
  },
  data(){
    return {
      prefix_countdown_text_dirty: false,
      is_upgrade_upper_master_modal: false,
    }
  },
  methods: {
    setCountdown(e){
      if (!this.show_with_parameters) {
        this.isDisplayModal(e);
      } else {
        this.$store.commit("creative/setCountdown", e.target.checked)
      }
    },
    updateBgColor(e){
      this.$store.commit("creative/setCountBgColor", e.hex)
    },
    updateFontColor(e){
      this.$store.commit("creative/setCountFontColor", e.hex)
    },
    updateCountdownName(e){
      this.$store.commit("creative/setCountdownName", e.target.value)
    },
    updatePrefixCountdownText(e){
      this.prefix_countdown_text_dirty = true
      this.$store.commit("creative/setPrefixCountdownText", e.target.value)
    },
    updateCountdownType(e){
      if(!this.prefix_countdown_text_dirty){
        if(e.target.value == "time_limit"){
          this.$store.commit("creative/setPrefixCountdownText", "販売終了まで")
        } else if( e.target.value == "day_end" ){
          this.$store.commit("creative/setPrefixCountdownText", "本日販売終了まで")
        } else if( e.target.value == "specific_date" ){
          this.$store.commit("creative/setPrefixCountdownText", "残り")
        }
      }
      if(e.target.value == "time_limit"){
        this.$store.commit("creative/setCountdownUnixTimeLeft")
      } else if( e.target.value == "specific_date" ){
        this.$store.commit("creative/setCountdownUnixTimeLeftFromSpecificDate")
      }
      this.$store.commit("creative/setCountdownType", e.target.value)
    },
    updateTimeLimitHour(e){
      this.$store.commit("creative/setTimeLimitHour", e.target.value)
      this.$store.commit("creative/setCountdownUnixTimeLeft")
    },
    updateTimeLimitMin(e){
      this.$store.commit("creative/setTimeLimitMin", e.target.value)
      this.$store.commit("creative/setCountdownUnixTimeLeft")
    },
    updateTimeLimitSpecificDate(e){
      this.$store.commit("creative/setTimeLimitSpecificDate", e.target.value)
      this.$store.commit("creative/setCountdownUnixTimeLeftFromSpecificDate")
    },
    isDisplayModal(e) {
      if (!this.show_with_parameters) {
        this.is_upgrade_upper_master_modal = true;
        event.preventDefault();
      }
    },
  },
  components: {
    Chrome,
    UpgradeUpperMaster,
  },
  watch: {},
  computed: {
    countdown(){
      return this.$store.state.creative.preview_list.countdown
    },
    countdown_bg_color(){
      return this.$store.state.creative.preview_list.countdown_bg_color
    },
    countdown_font_color(){
      return this.$store.state.creative.preview_list.countdown_font_color
    },
    countdown_name(){
      return this.$store.state.creative.preview_list.countdown_name
    },
    prefix_countdown_text(){
      return this.$store.state.creative.preview_list.prefix_countdown_text
    },
    time_limit_min(){
      return this.$store.state.creative.preview_list.time_limit_min
    },
    time_limit_hour(){
      return this.$store.state.creative.preview_list.time_limit_hour
    },
    countdown_type(){
      return this.$store.state.creative.preview_list.countdown_type
    },
    time_limit_specific_date(){
      console.log("this.$store.state.creative.preview_list.time_limit_specific_date",this.$store.state.creative.preview_list.time_limit_specific_date)
      return this.$store.state.creative.preview_list.time_limit_specific_date
    }
  },
  async mounted(){
  }
}
</script>
<style lang="scss" scoped>

</style>
